export default __webpack_public_path__ + "static/media/003-axe.eea724e0.svg";